$(function(){
	var sliderRecipe = [];
	var winW = $(window).width(),
		winH = $(window).height();

	$(window).on('resize', onResize);
	function onResize(){
		var winS_w = window.innerWidth;

			winW = $(window).width(),
		    winH = $(window).height();

		if(winS_w > 959 && (!$('#hamburger.open').length)){
			$("nav").css("display","block");
		} else if (winS_w <= 959 && $("#hamburger").hasClass("open")){
			$("nav").css("display","block");
		} else if (winS_w <= 959 && (!$('#hamburger.open').length)){
			$("nav").css("display","none");
		}

		if(winW < 960){
			$("#content").css("padding-top","55px");
		} else {
			$("#content").css("padding-top","100px");
		}

	}
	onResize();

	function menu_func() {
		$("#hamburger").on("click",function(){
			if($(this).hasClass('open')){
				menu_close_func();
			}else {
				menu_open_func();
			}
		});	
	}
	menu_func();
	function menu_close_func(){
		if(winW < 959){
			$("#hamburger").removeClass('open');
			$("nav").slideUp('slow');
		}
	}
	function menu_open_func(){
		$("#hamburger").addClass('open');
		$("nav").slideDown('slow');
	}
});